import React from 'react';
export function Footer() {
  return <footer className="bg-[#1e293b] text-slate-400 py-6 md:py-10 border-t border-white/5" data-id="element-46">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-47">
        <span className="text-white font-bold text-lg tracking-tight" data-id="element-48">
          SIC 360
        </span>
        <p className="mt-2 text-xs md:text-sm" data-id="element-49">
          © 2026 SIC 360 — RincónDocente360. Todos los derechos reservados.
        </p>
        <p className="mt-1 text-[10px] md:text-xs text-slate-500 uppercase tracking-widest" data-id="element-50">
          RincónDocente360 · Recursos profesionales para docentes argentinos
        </p>
      </div>
    </footer>;
}